import axios from 'axios'


export const baseUrl  = `https://tto.suizoargentina.com`
export const TTO = 'https://tto.suizoargentina.com/dispensa'
export const TEST = 'https://tto.suizoargentina.com/test'
export const TTOLIQ = 'https://tto.suizoargentina.com/liquidacionDispensa'
export const TTOLOGIN = 'https://tto.suizoargentina.com/dispensaLogin'
export const LIQ      = 'https://apisc.farmaonline.com/sellercomisiones'
export const FOLIQ = 'https://apisc.farmaonline.com/vtexliquidaciones'
export const FARMACIA = 'https://apisc.farmaonline.com/farmacia'
export const ROBOTS = 'https://tto.suizoargentina.com/dispensaRobot'
export const DM = 'https://tto.suizoargentina.com/DispositivosMedicos'

export const V2 = 'https://server104.suizoargentina.com/api/ttosbot/v2'

// export const imgUrl = ``
export const HTTP = axios.create({
    baseURL: baseUrl,
    headers: {
        'Authorization': `Bearer ${window.sessionStorage.getItem('token')}`,
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        // 'Content-Type': 'multipart/form-data' ,
        // 'Content-Type': 'application/x-www-form-urlencoded'

    },
    crossDomain: true
})